<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-form-group label="Number of Rooms" label-for="numberOfRooms" label-cols-sm="4" label-cols-lg="3">
        <b-form-input id="numberOfRooms" type="number" placeholder="Please choose the number of rooms" @change="changeNumberOfRooms" />
      </b-form-group>
    </b-card-body>
  </b-card>

  <b-card no-body>
    <b-card-body>
      <strong>Available buildings</strong>
      <b-row>
        <b-col lg="12">
          <v-client-table :data="buildings" :columns="columns" :options="options" :theme="theme" id="buildingDataTable">
            <template slot="select" slot-scope="data">
              <b-btn variant="outline-primary" v-if="numberOfRooms > 0 && data.row.avail_rooms >= numberOfRooms" @click="selectBuilding(data.row.id)">Select</b-btn>
            </template>
          </v-client-table>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

</div>
</template>

<script>
import BuildingAutoSearch from './BuildingAutoSearch'
import {
  mapState,
} from 'vuex'

export default {
  name: "MultipleAutoMatching",
  props: {
    reservations: Array
  },
  components: {
    BuildingAutoSearch,
  },
  computed: mapState({
    buildings: state => state.reservations.availableBuildings,
    availRooms: state => state.reservations.availableRooms
  }),
  data() {
    return {
      numberOfRooms: 0,
      columns: [
        'name',
        'total_rooms',
        'avail_rooms',
        'select'
      ],
      options: {
        headings: {
          name: 'Name',
          total_rooms: 'Total Rooms',
          avail_rooms: 'Available Rooms',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    changeNumberOfRooms(number) {
      this.numberOfRooms = number
    },
    selectBuilding(buildingId) {
      let selectedIds = _.map(this.selectedRooms, room => room.id)
      let reservationIds = _.map(this.reservations, reservation => reservation.id)
      this.$store.dispatch('reservations/setMultipleAutoRooms', {reservation_ids: reservationIds, building_id: buildingId, number_of_rooms: parseInt(this.numberOfRooms)})
      .then(() => {
        this.$emit('submit')
        this.showSuccessMsg()
      })
      .catch((error) => {
        if (error.response.status == 400) {
          this.showErrorMsg({
            message: error.response.data.message
          })
        } else {
          this.showErrorMsg()
        }
      })
    }
  },
  created() {
    let startDate = '2100-31-12'
    let endDate = '1970-01-01'
    _.each(this.reservations, (reservation) => {
      let arrival = this.formatDate(reservation.arrival_date)
      let departure = this.formatDate(reservation.departure_date)
      if (startDate > arrival) {
        startDate = arrival
      }
      if (endDate < departure) {
        endDate = departure
      }
    })
    this.$store.dispatch('reservations/searchAvailableRooms', {arrival: startDate, departure: endDate})
  }
}
</script>
